// extracted by mini-css-extract-plugin
export var Grey = "FloatingCallout-module--Grey--ba972";
export var White = "FloatingCallout-module--White--902dd";
export var backgroundOverlap = "FloatingCallout-module--background-overlap--9715f";
export var container = "FloatingCallout-module--container--26afe";
export var copy = "FloatingCallout-module--copy--90561";
export var floatingCallout = "FloatingCallout-module--floating-callout--ae404";
export var image = "FloatingCallout-module--image--78d93";
export var imageBleed = "FloatingCallout-module--image-bleed--2c7b3";
export var imageLeft = "FloatingCallout-module--image-left--8e4c9";
export var rounded = "FloatingCallout-module--rounded--22555";
export var shadow = "FloatingCallout-module--shadow--47469";
export var subtitle = "FloatingCallout-module--subtitle--9da85";
export var videoPlayer = "FloatingCallout-module--video-player--59752";
export var wide = "FloatingCallout-module--wide--b18f4";
export var wrapper = "FloatingCallout-module--wrapper--a1f70";